import React from "react";
import { Button } from "react-bootstrap";

export default function EditButton(props) {

    return (
        <React.Fragment>
            <Button className="btn btn-sm btn-primary" title="Modifier" onClick={props.action}>
                <i className="fas fa-edit"></i></Button>
        </React.Fragment>
    )
}